module.exports = __webpack_public_path__ + "static/IMG_3941-9674d9f9b59a318832578e46a9771928.jpg";